// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2102":"469ece58","9184":"d2b8ee2f"}[chunkId] + ".chunk.css";
};